import Renderer from '../rendering/Renderer';
import Object3D from '../rendering/Object3D';
import Mesh3D_TRIANGLE_normal from '../meshes/Mesh3D_TRIANGLE_normal';
import { Shader, VertexShader, FragmentShader, ShaderProgram } from '../rendering/Shader';
import CubeGeometry from '../geometries/CubeGeometry';
import Vector3 from '../math/Vector3';

import RGB from '../colors/RGB';
import SpecularRGB from '../colors/SpecularRGB';

const defaultVertexScript = require('./shaders/vertex/colorMesh.vert');
const defaultFragmentScript = require('./shaders/fragment/colorMesh.frag');

const depthVertexScript = require('./shaders/vertex/depth.vert');
const depthFragmentScript = require('./shaders/fragment/depth.frag');

const shadedVertexScript = require('./shaders/vertex/shadedColor.vert');
const shadedFragmentScript = require('./shaders/fragment/shadedColor.frag');

const defaultVertexShader = new VertexShader(defaultVertexScript, ['aVertexPosition', 'aVertexNormal'], ['uMMatrix', 'uCameraPosition']);
const defaultFragmentShader = new FragmentShader(defaultFragmentScript, ['uColor', 'uSpecularColor', 'uAmbientLight', 'uDirectionalLight', 'uLightDirection']);
const defaultShader = new Shader(defaultVertexShader, defaultFragmentShader);

const depthVertexShader = new VertexShader(depthVertexScript, ['aVertexPosition'], ['uMMatrix']);
const depthFragmentShader = new FragmentShader(depthFragmentScript, []);
const depthShader = new Shader(depthVertexShader, depthFragmentShader);

const shadedVertexShader = new VertexShader(shadedVertexScript, ['aVertexPosition', 'aVertexNormal'], ['uMMatrix', 'uCameraPosition', 'uShadowMapVPMatrix']);
const shadedFragmentShader = new FragmentShader(shadedFragmentScript, ['uColor', 'uSpecularColor', 'uAmbientLight', 'uDirectionalLight', 'uLightDirection'], ['uShadowMap']);
const shadedShader = new Shader(shadedVertexShader, shadedFragmentShader);

const shaders = {
	default: defaultShader,
	depth: depthShader,
	shaded: shadedShader
};

const cubeMesh = new Mesh3D_TRIANGLE_normal(new CubeGeometry(1, new Vector3(0, 0, 0)));

export default class ColoredObject extends Object3D {
	color: RGB;
	specular: SpecularRGB;
	mesh: Mesh3D_TRIANGLE_normal;

	shaders = shaders;

	constructor () {
		super();

		this.color = new RGB(1.0, 0.5, 0.2);
		this.specular = new SpecularRGB(1.0, 1.0, 1.0, 0.01);

		this.mesh = cubeMesh;
	}

	renderDefault (renderer: Renderer, program: ShaderProgram) {
		const gl = renderer.gl;
		const uniforms = program.uniforms;
		const color = this.color;
		gl.uniform3f(uniforms.uColor,
			color.r,
			color.g,
			color.b
		);

		const specular = this.specular;
		gl.uniform4f(uniforms.uSpecularColor,
			specular.r,
			specular.g,
			specular.b,
			1 / specular.lobe
		);

		this.mesh.render(renderer, program, true);
	}

	renderDepth (renderer: Renderer, program: ShaderProgram) {
		this.mesh.render(renderer, program, false);
	}

	renderShaded = this.renderDefault
}
